module.exports = __webpack_public_path__ + "img/link-recruta.4c47c30c.svg";